/**
 * Cart Drawer vs Page A/B Test
 * - Variant (cart-page-variant): abre el drawer al add-to-cart y al clic en el icono.
 * - Control: redirige a /cart en ambos casos.
 * Requiere cart_type: "drawer" en theme settings para que el drawer exista.
 * Works with Intelligems (API) or Convert/Intelligems Modifications (body class).
 */
(function () {
  const CART_PAGE_AB_CONFIG = {
    intelligemsExperimentName: 'Cart Page Test',
    intelligemsVariantCheck: function (group) {
      return group && !group.isControl;
    },
  };

  function isDrawerVariant() {
    // Single source of truth: Intelligems / manual test adds `cart-page-variant` for the drawer arm.
    // No default when IG is slow — avoids opening the drawer and then redirecting to /cart (control).
    return document.body.classList.contains('cart-page-variant');
  }

  function isOnCartPage() {
    var cartUrl = window.routes?.cart_url;
    if (!cartUrl) return false;
    try {
      return new URL(cartUrl, window.location.href).pathname === window.location.pathname;
    } catch (e) {
      return false;
    }
  }

  function applyVariantFromIntelligems() {
    if (typeof window.igData === 'undefined' || !window.igData.user) return;

    const experiments = window.igData.user.getExperiments();
    const experiment = experiments.find(
      (e) => e.name === CART_PAGE_AB_CONFIG.intelligemsExperimentName
    );
    if (!experiment) return;

    const group = window.igData.user.getTestGroup(experiment.id);
    if (CART_PAGE_AB_CONFIG.intelligemsVariantCheck(group)) {
      document.body.classList.add('cart-page-variant');
    }
  }

  let listenersAttached = false;
  let reploAddListenersAttached = false;

  /**
   * Replo cards use <product-form> with the add button outside the form and no [type="submit"],
   * so ProductForm never binds — Replo's script adds to cart and often navigates to /cart.
   * When the drawer A/B variant is active, intercept and use the same AJAX flow as the theme.
   */
  function initReploDrawerAddToCart() {
    if (reploAddListenersAttached) return;
    reploAddListenersAttached = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!isDrawerVariant()) return;
        if (!e.target || !e.target.closest) return;

        var reploBtn = e.target.closest('[data-replo-add-product-variant-to-cart]');
        if (!reploBtn) return;

        var container = reploBtn.closest('[data-replo-product-container]');
        if (!container) return;

        var form = container.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        var cartDrawerEl = document.querySelector('cart-drawer');
        if (!cartDrawerEl || typeof cartDrawerEl.getSectionsToRender !== 'function') return;

        if (reploBtn.getAttribute('aria-disabled') === 'true') return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var idInput = form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = false;

        var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var formData = new FormData(form);
        formData.append(
          'sections',
          cartDrawerEl.getSectionsToRender().map(function (section) {
            return section.id;
          })
        );
        formData.append('sections_url', window.location.pathname);
        cartDrawerEl.setActiveElement(reploBtn);
        config.body = formData;

        reploBtn.setAttribute('aria-disabled', 'true');
        reploBtn.classList.add('loading');

        var cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';

        fetch(cartAddUrl, config)
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'replo-cart',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            cartDrawerEl.renderContents(response);
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(function () {
            reploBtn.removeAttribute('aria-disabled');
            reploBtn.classList.remove('loading');
            if (cartDrawerEl && cartDrawerEl.classList.contains('is-empty')) {
              cartDrawerEl.classList.remove('is-empty');
            }
          });
      },
      true
    );
  }

  function initCartPageAbTest() {
    if (typeof window.igData !== 'undefined' && window.igData.user) {
      applyVariantFromIntelligems();
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    initReploDrawerAddToCart();

    if (listenersAttached) return;
    listenersAttached = true;

    var cartUrl = window.routes?.cart_url || '/cart';
    var cartDrawerEl = document.querySelector('cart-drawer');

    document.addEventListener(
      'click',
      function (e) {
        if (isOnCartPage()) return;
        if (!e.target || !e.target.closest) return;

        // Ignore third-party OCU/Zipify UI so "Add to order" links/buttons are never hijacked.
        if (e.target.closest('[data-ocu], [data-zipify], [id*="zipify"], [class*="zipify"]')) return;

        // Only hijack the real cart icon trigger from header UI.
        var cartIconTrigger =
          e.target.closest('a#cart-icon-bubble') ||
          e.target.closest('a.header__icon--cart') ||
          e.target.closest('.header__icon--cart') ||
          e.target.closest('[data-cart-icon]') ||
          e.target.closest('.cart-bubble') ||
          e.target.closest('.cart-icon');
        if (!cartIconTrigger) return;
        if (
          cartIconTrigger.closest &&
          (cartIconTrigger.closest('cart-drawer') || cartIconTrigger.closest('cart-notification'))
        ) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (isDrawerVariant() && cartDrawerEl) {
          cartDrawerEl.open(cartIconTrigger);
        } else {
          window.location = cartUrl;
        }
      },
      true
    );

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!isDrawerVariant() && event?.source === 'product-form') {
          window.location = cartUrl;
        }
      });
    }
  }

  function run() {
    initCartPageAbTest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('ig:ready', run);
  if (typeof window.onIgReady !== 'undefined') {
    const prev = window.onIgReady;
    window.onIgReady = Array.isArray(prev) ? [...prev, run] : prev ? [prev, run] : run;
  } else {
    window.onIgReady = run;
  }
})();
